import React, {Component} from "react";
import {connect} from "react-redux";
import ACTIONS from "../constants/actions";
import Loading from "./Loading";
import Draggable from "react-draggable";

class Modal extends Component {
	state = {
		isOpened   : false,
		isLoading  : true,
		isViewMode : false,
	};

	componentWillMount() {
		this.setState({
			isLoading : !this.state.isLoading
		});
	}

	componentWillReceiveProps(nextProps) {
		if ( nextProps.videoModal.frame ) {
			this.setState({
				isOpened : true,
			});
		}
	}

	close() {
		this.props.updateVideoModal({});

		this.setState({
			isOpened : !this.state.isOpened
		});
	}

	toggleViewMode() {
		this.setState({
			isViewMode : !this.state.isViewMode
		});
	}

	render() {
		const {videoModal} = this.props;

		return (
			<div>
				<Draggable disabled={this.state.isViewMode}>
					<div className={`modalbox ${this.state.isOpened && 'show'} ${this.state.isViewMode && 'viewMode'}`} ref="modalbox">
						<div className="modalbox__header">
							<div className="modalbox__header__title">
								{videoModal.title}
							</div>
							<div className="modalbox__header__buttons">
								<div className={`gotoViewMode ${this.state.isViewMode && 'active'}`}
								     onClick={this.toggleViewMode.bind(this)}
								     title={this.state.isViewMode ? "Перейти в компактный режим" : "Перейти в режим просмотра"}>
									<i className="fas fa-eye"></i>
								</div>
								<div className="close" onClick={this.close.bind(this)}>
									<i className="fas fa-times"></i>
								</div>
							</div>
						</div>

						<div className={`modalbox__content`}>
							{this.state.isLoading && <Loading/>}
							{videoModal.frame}
						</div>
					</div>
				</Draggable>
				{this.state.isViewMode && <div className={`modalbox__splash ${this.state.isOpened && 'show'}`}></div>}
			</div>
		);
	}
}

export default connect(
	state => ({
		videoModal : state.videoModal
	}),
	dispatch => ({
		updateVideoModal : (data) => {
			dispatch({type : ACTIONS.VIDEO_MODAL.UPDATE, data : data})
		}
	})
)(Modal);


// WEBPACK FOOTER //
// ./src/app/components/Modal.js